import { render, staticRenderFns } from "./DashboardProgressbar.vue?vue&type=template&id=97bde96e&scoped=true"
import script from "./DashboardProgressbar.vue?vue&type=script&lang=js"
export * from "./DashboardProgressbar.vue?vue&type=script&lang=js"
import style0 from "./DashboardProgressbar.vue?vue&type=style&index=0&id=97bde96e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97bde96e",
  null
  
)

export default component.exports